<template>
  <div class="flex flex-wrap gap-4 mt-6 mb-12">
    <div class="bg-white w-full m-auto shadow-ts1 rounded-lg">
      <div class="px-6 py-5 border-b border-gray-400 flex justify-between items-center">
        <h2 class="font-display text-xl font-bold text-blue leading-none">{{ $t('newsletter').tTitle() }}</h2>
        <a target="_blank" :href="`${websiteURL}tools/newsletter`" class="w-28 py-0.5 table text-black font-medium text-center text-sm">{{ $t('learn_more').tTitle() }} </a>
      </div>
      <div class="w-full px-4 md:px-8 pt-5">
        <div class="grid grid-cols-1-default md:grid-cols-2-default w-full xl:w-[85%] m-auto items-center px-5">
          <div>
            <p class="text-blue text-[40px] mb-[35px] md:mb-[40px] font-bold">{{ $t('newsletter_title') }}</p>
            <p class="text-[16px] leading-7">
              {{ $t('newsletter_description') }}
            </p>
            <button
              v-if="isSubscribed"
              target="_blank"
              class="w-[180px] text-center text-white rounded-md py-3 px-4 text-base font-bold table mt-6 mb-4 relative z-10 bg-gray-900"
              @click="unsubscribe"
            >
              {{ $t('unsubscribe') }}
            </button>
            <button
              v-else
              target="_blank"
              class="w-[180px] text-center text-white rounded-md py-3 px-4 text-base font-bold table mt-6 mb-4 relative z-10 bg-green"
              @click="newsletterSubscribe"
            >
              {{ $t('subscribe') }}
            </button>
          </div>
          <img src="../../assets/img/plexytrade-newsletter.webp" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import config from '../../config'
import { service } from '../../main.js'

export default {
  data() {
    return {
      websiteURL: config.URL.website,
      isSubscribed: false,
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      logoLoaderActive: 'logoLoader/active',
    }),
  },
  mounted() {
    this.isUserSubscribed()
  },
  created() {},
  methods: {
    async isUserSubscribed() {
      try {
        const response = await service.post('/tradingcentral/is-user-subscribed', { user_id: this.User.info.ID })
        if (response && response.data) {
          if (response.data) return (this.isSubscribed = true)
        }
      } catch (error) {
        this.$toasted.error(this.$t('sub_status_check_fail') + error)
      }
    },
    newsletterSubscribe() {
      // this['logoLoader/set'](true)
      service
        .post('tradingcentral/newsletter/request', {
          user_id: this.User.info.ID,
          action: 'subscribe',
          email: this.User.info.email,
        })
        .then(response => {
          if (response) {
            if (response.data.is_active) {
              this.$toasted.success(this.$t('newsletter_sub_full').tTitle())
              this.isSubscribed = true
            }
          }
          // this['logoLoader/set'](false)
        })
        .catch(error => {
          this.$toasted.error(this.$t('news_sub_req_fail') + error)
          // this['logoLoader/set'](false)
        })
    },
    unsubscribe() {
      // this['logoLoader/set'](true)
      service
        .post('tradingcentral/newsletter/request', {
          user_id: this.User.info.ID,
          action: 'unsubscribe',
          email: this.User.info.email,
        })
        .then(response => {
          if (!response.data.is_active) {
            this.$toasted.success(this.$t('newsletter_unsubscribe').tTitle())
            this.isSubscribed = false
            // this['logoLoader/set'](false)
          }
        })
        .catch(error => {
          this.$toasted.error(this.$t('news_sub_req_fail') + error)
          // this['logoLoader/set'](false)
        })
    },
    ...mapActions(['logoLoader/set', 'logoLoader/text']),
  },
}
</script>
